import { fillCost } from '@/api/advertiser'

export default {
    components: {},
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        },
    },
    data() {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            rules: {
                day: [{ required: true, message: '请选择投放日期', trigger: 'change' }],
                cost: [{ required: true, message: '请填写当日消耗金额', trigger: 'change' }],
            },
            admins:[],
        }
    },
    computed: {},
    mounted() {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.fillCost()
            })
        },
        fillCost() {
            this.loading = true
            fillCost(this.model).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('操作成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showForm', false)
        }
    }
}
